<a [routerLink]="['..']" class="adap-link link-return">
  <mat-icon svgIcon="cvx-left"></mat-icon>
  global settings
</a>

<div class="group-container header">
  <div class="header-title">peer pool disciplines</div>
  <button
    class="adap-btn-filled add-peer-pool-discipline-button"
    type="button"
    (click)="addPeerPoolDiscipline()"
  >
    add peer pool discipline <mat-icon svgIcon="cvx-plus-circle"></mat-icon>
  </button>

  <app-peer-pool-disciplines-table
    (editPeerPoolDiscipline)="editPeerPoolDiscipline($event)"
    (deletePeerPoolDiscipline)="deletePeerPoolDiscipline($event)"
  ></app-peer-pool-disciplines-table>
</div>
